module.exports = __webpack_public_path__ + "Roboto-Regular-webfont.30799efa5bf74129468a.eot";


//////////////////
// WEBPACK FOOTER
// /Users/mac-jeremy/Projets/fairepart/src/assets/fonts/roboto/roboto_regular_macroman/Roboto-Regular-webfont.eot
// module id = ../../../../../src/assets/fonts/roboto/roboto_regular_macroman/Roboto-Regular-webfont.eot
// module chunks = 1